if (!customElements.get('luma-showcase')) customElements.define('luma-showcase', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.track = this.querySelector('.luma-showcase__track');
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.dots = [...this.querySelectorAll('[data-go]')];
    this.index = 0;
    this.go = (index) => this.track.scrollTo({left: this.slides[(index + this.slides.length) % this.slides.length].offsetLeft - this.slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1));
    this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
    this.track.addEventListener('keydown', (event) => {
      if (event.target !== this.track) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1)); }
    });
    this.track.addEventListener('scroll', () => {
      const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
      if (index === this.index) return;
      this.index = index;
      this.dots.forEach((dot, i) => i === index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
    }, {passive: true});
    this.addEventListener('shopify:block:select', (event) => {const i = this.slides.indexOf(event.target.closest('[data-slide]')); if(i >= 0) this.go(i);});
  }
});
if (!customElements.get('luma-sticky-purchase')) customElements.define('luma-sticky-purchase', class extends HTMLElement {
  connectedCallback() {
    this.main = document.getElementById('MainProduct-' + this.dataset.section);
    this.native = this.main?.querySelector('.product-form__submit');
    this.button = this.querySelector('[data-sticky-submit]');
    if (!this.native) return;
    this.updateVisibility = () => {
      if (this.visibilityFrame) return;
      this.visibilityFrame = requestAnimationFrame(() => {
        this.hidden = this.native.getBoundingClientRect().bottom >= 0;
        this.visibilityFrame = null;
      });
    };
    const update = () => {
      const disabled = this.native.disabled || this.native.getAttribute('aria-disabled') === 'true';
      if (this.button.disabled !== disabled) this.button.disabled = disabled;
      const label = this.native.querySelector('span')?.textContent.trim();
      if (label && this.button.textContent !== label) this.button.textContent = label;
      const price = this.main.querySelector('.price:not(.price--on-sale) .price__regular .price-item--regular, .price.price--on-sale .price-item--sale');
      const stickyPrice = this.querySelector('[data-sticky-price]');
      if (price && stickyPrice.textContent !== price.textContent.trim()) stickyPrice.textContent = price.textContent.trim();
      this.updateVisibility();
    };
    this.observer = new MutationObserver(update);
    this.observer.observe(this.main, {subtree: true, childList: true, attributes: true, attributeFilter: ['disabled','aria-disabled']});
    window.addEventListener('scroll', this.updateVisibility, {passive: true});
    window.addEventListener('resize', this.updateVisibility);
    this.button.addEventListener('click', () => {if (!this.button.disabled) this.native.click();});
    update();
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    window.removeEventListener('scroll', this.updateVisibility);
    window.removeEventListener('resize', this.updateVisibility);
    cancelAnimationFrame(this.visibilityFrame);
  }
});
if (!customElements.get('luma-scent-finder')) customElements.define('luma-scent-finder', class extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', event => {
      const button = event.target.closest('[data-family]');
      if (!button) return;
      this.querySelectorAll('[data-family]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      let count = 0;
      this.querySelectorAll('[data-scent-family]').forEach(card => {card.hidden = button.dataset.family !== 'all' && card.dataset.scentFamily !== button.dataset.family; if(!card.hidden) count++;});
      const status = this.querySelector('[data-finder-status]');
      status.textContent = count + ' ' + status.dataset.message;
    });
  }
});
